/**
 * Uma linha de vínculo, no recorte mínimo que a navegação precisa: o papel da
 * pessoa e o tipo da casa.
 */
export interface RoleRow {
  institutionId: string;
  role: string;
  institutionType: string;
}

/**
 * O que a navegação precisa saber da conta, derivado dos vínculos **ativos**.
 *
 * - `hqInstitutionId`: o primeiro QG de que a pessoa participa. Participar do QG
 *   já dá o mapa da operação (revisão de produto de 2026-08-16), então basta o
 *   vínculo — não é preciso atender pedidos.
 * - `ownedInstitutionId`: a instituição de que a pessoa é dona. É o que separa
 *   "conta institucional" (abre direto o perfil da casa) de quem só voluntaria.
 */
export interface InstitutionRoles {
  hqInstitutionId: string | null;
  ownedInstitutionId: string | null;
}

export const NO_INSTITUTION_ROLES: InstitutionRoles = {
  hqInstitutionId: null,
  ownedInstitutionId: null,
};

export function deriveInstitutionRoles(rows: RoleRow[]): InstitutionRoles {
  const hq = rows.find((row) => row.institutionType === 'hq');
  const owned = rows.find((row) => row.role === 'owner');

  return {
    hqInstitutionId: hq?.institutionId ?? null,
    ownedInstitutionId: owned?.institutionId ?? null,
  };
}
